const forms = {
  onRequest: "अनुरोध पर", // translated 
  person: "व्यक्ति", // translated 
  travelDate: "यात्रा तिथि", // translated 
  travelDates: "यात्रा की तारीखें", // translated 
  cancel: "रद्द करना", // translated 
  getPrice: "कीमत प्राप्त करें", // translated 
};


export default forms;
